import axios from 'axios'; // 引入axios
import $cookies from 'vue-cookies'

// axios.defaults.baseURL = process.env.API_ROOT
// axios.defaults.timeout = 50000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const http = axios.create({
	baseURL: process.env.API_ROOT,
	timeout:50000,
})

const client = process.env.AUTH_CLIENT

function withToken() {
    // 超时验证
    let access_token = $cookies.get("api_access_token");
    // let now = new Date().getTime();
    // let lastTokenTime = parseInt($cookies.get("api_access_token_time") || '0');
    // 防止token过期，半小时重取一次
    // let tokenIsExpire = (!access_token || (now - lastTokenTime > 1800000));
    let tokenIsExpire = (!access_token);
    if (tokenIsExpire) {
        return new Promise((resolve, reject) => {
            http.post("/service-auth/oauth/token", {}, { params: client }).then(res => {
                let token = "";
                if (res.data && res.data.access_token) {
                    token = res.data.access_token
                    $cookies.set("api_access_token_time", `${new Date().getTime()}`);
                    $cookies.set("api_access_token", token);
                } else {
                    console.error("获取access_token失败。");
                    // 清除token重新获取
                    $cookies.remove("api_access_token_time");
                    $cookies.remove("api_access_token");
                }
                resolve(token)
            }).catch(err => {
                console.error(err)
                reject(err)
            })
        })
    } else {
        return Promise.resolve(access_token);
    }
}

function tokenFirst(params) {
    return http.post("/service-auth/oauth/token", {}, { params: client })
}

/**
 * 封装get请求
 * @param url
 * @param params
 * @returns {Promise}
 */
/*let get = (url, params = {}) => {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}*/
// function get(url, params, headers) {
//     let access_token = this.$cookies.get("api_access_token");
//     return new Promise((resolve) => {
//         withToken().then(token => {
//             axios.get(`${url}?access_token=${token}`, {params,
//                 headers: {
//                     'Authorization': 'Basic ' + access_token	//	可以是授权凭证用的参数值
//                 }
//                }).then(res => {
//                 resolve(res.data)
//             })
//         })
//     })
// }
function get(url, params, headers) {
    return new Promise((resolve,reject) => {
        withToken().then(token => {
            if(url.indexOf('edu.zhuzaocloud.com')>-1){
                console.log("-----------------")
                console.log(url)
                console.log(params)
                console.log(http)
            }
            http.get(url, {
                params,
                headers: {
                    'Authorization': 'Bearer ' + token	//	可以是授权凭证用的参数值
                }
            }).then(res => {
                resolve(res.data)
            }).catch((err)=>{
                reject(err)
            })
        })
    })
}
function getBlobFile(url, params, headers) {
    return new Promise((resolve) => {
        withToken().then(token => {
            http.get(url, {
                params,
                headers: {
                    'Authorization': 'Bearer ' + token	//	可以是授权凭证用的参数值
                },
                responseType: 'blob'
            }).then(res => {
                resolve(res.data)
            }).catch((res) => {
                resolve(res)
            })
        })
    })
}

function getFile(url, params, headers) {
    return new Promise((resolve) => {
        withToken().then(token => {
            http.get(url, {
                params,
                headers: {
                    'Authorization': 'Bearer ' + token	//	可以是授权凭证用的参数值
                },
                responseType: 'arraybuffer'
            }).then(res => {
                resolve(res)
            }).catch((res)=>{
                resolve(res)
            })
        })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @param headers
 * @returns {Promise}
 */
/*let post = (url, data = {}, headers) => {
    return new Promise((resolve, reject) => {
        let params = {
            url,
            method: "post",
            data,
            transformRequest: [function (data) {
                var oMyForm = new FormData();
                var keys = Object.keys(data)
                keys.forEach(k => {
                    oMyForm.append(k, data[k]);
                })
                return oMyForm;
            }]
        }
        if (headers) params.headers = headers
        //表单形式提交
        axios(params).then(response => {
            console.log(response)
            resolve(response.data);
        }).catch(err => {
            console.error(err)
            reject(err)
        })
    })
}*/

function post(url, params, headers) {

    return new Promise((resolve, reject) => {
        withToken().then(token => {
            url = url.replace(/(.*)\/$/, "$1")
            http.post(`${url}`, params, {
                headers: {
                    'Authorization': 'Bearer ' + token	//	可以是授权凭证用的参数值
                }
            }).then(res => {
                resolve(res.data)
            }).catch((err)=>{
                console.error(err)
                reject(err)
            })
        })
    })
}
// put方法
function put(url, params, headers) {

    return new Promise((resolve,reject) => {
        withToken().then(token => {
            url = url.replace(/(.*)\/$/, "$1")
            http.put(`${url}`, params, {
                headers: {
                    'Authorization': 'Bearer ' + token	//	可以是授权凭证用的参数值
                }
            }).then(res => {
                resolve(res.data)
            }).catch((err)=>{
                console.error(err)
                reject(err)
            })
        })
    })
}
// delete 方法
function deleteUrl(url, params, headers) {
    return new Promise((resolve) => {
        withToken().then(token => {
            url = url.replace(/(.*)\/$/, "$1");
            http.delete(url, {
                params,
                headers: {
                    'Authorization': 'Bearer ' + token	//	可以是授权凭证用的参数值
                }
            }).then(res => {
                resolve(res.data)
            }).catch((res)=>{
                resolve(res)
            })
        })
    })
}
// del
function deleteApi(url, params, headers) {
    return new Promise((resolve) => {
        withToken().then(token => {
            url = url.replace(/(.*)\/$/, "$1");
            http.delete(url, {
                data: params,
                headers: {
                    'Authorization': 'Bearer ' + token	//	可以是授权凭证用的参数值
                }
            }).then(res => {
                resolve(res.data)
            }).catch((res)=>{
                resolve(res)
            })
        })
    })
}

export default { get,getBlobFile, post, put, tokenFirst, deleteUrl, getFile, deleteApi }



// WEBPACK FOOTER //
// ./src/utils/api.js